<template>
  <div
    v-if="hasForeignLists"
    class="lastOpenedWishlists"
  >
    <div class="modal-title mb-2">
      Ihre letzten Besuche auf geteilten Listen:
    </div>
    <ul>
      <li
        v-for="(list, index) in filteredGuestLists"
        :key="index"
      >
        <a

          :class="'wishlist_design_' + list.colorScheme"
          :href="'/wunschliste/' + list.accessCode + '/'"
        >{{ list.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import loadWishlistModule from '../mixins/loadWishlistModule'

export default {
  name: 'BkLastOpenedWishlists',
  mixins: [loadWishlistModule],
  computed: {
    ...mapState({
      lastVisitedGuestLists: state => state.bkwishlist.lastVisitedGuestWishlists,
      userWishlists: state => state.bkwishlist.userWishlists
    }),
    filteredGuestLists () {
      return this.lastVisitedGuestLists.filter(wishlist => !this.userWishlists.some(w => w.accessCode === wishlist.accessCode))
    },
    hasForeignLists () {
      return (this.filteredGuestLists.length > 0)
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('initLastVisitedGuestWishlists')
    }
  }
}
</script>
